(() => {
  if (window.voltOrdersReady) return;
  window.voltOrdersReady = true;
  function init() {
    document.querySelectorAll('[data-volt-orders]').forEach(root => {
      if (root.dataset.ready || !root.querySelector('[data-order-tools]')) return;
      root.dataset.ready = 'true';
      const search = root.querySelector('[data-order-search]');
      const cards = [...root.querySelectorAll('[data-order-card]')];
      const buttons = [...root.querySelectorAll('[data-order-filter]')];
      const empty = root.querySelector('[data-order-empty]');
      const result = root.querySelector('[data-order-count]');
      const fold = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('ro');
      const searchable = new Map(cards.map(card => [card, fold(card.textContent)]));
      let group = 'all';
      function filter() {
        const query = fold(search.value.trim());
        let count = 0;
        cards.forEach(card => {
          const show = (group === 'all' || card.dataset.orderGroup === group) && searchable.get(card).includes(query);
          card.hidden = !show;
          if (show) count++;
        });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.orderFilter === group)));
        empty.hidden = count > 0;
        result.textContent = result.dataset.template.replace('__COUNT__', String(count));
        result.hidden = false;
      }
      search.addEventListener('input', filter);
      buttons.forEach(button => button.addEventListener('click', () => { group = button.dataset.orderFilter; filter(); }));
      root.querySelector('[data-order-reset]').addEventListener('click', () => { group = 'all'; search.value = ''; filter(); search.focus(); });
      root.querySelector('[data-order-tools]').hidden = false;
      filter();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', event => { if (event.persisted) window.location.reload(); });
})();
